<template>
  <div id="app">


    <el-container>
      <el-aside width="250px">
        <Navigation/>
      </el-aside>

      <el-container>
        <el-main>
          <router-view/>
        </el-main>
      </el-container>

    </el-container>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue';

export default {
  name: 'app',
  components: {
    Navigation,
  },
};
</script>

<style>
  html {
    font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,sans-serif;
  }
  html, body {
    margin: 0;
    padding: 0;
  }
  /*.el-dialog__header {*/
  /*  background-color: #f5f5f5;*/
  /*  border-bottom: 1px solid #eee;*/
  /*}*/

  aside {
    background-color: #545c64;
  }

  .el-menu {
    border-right: none !important;
  }

  .el-tag--dark {
    width: 100%;
    text-align: center;
  }
</style>
